import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Tooltip, Modal, Button } from "react-bootstrap";
import { widgetWallUpdate } from "../../../../../../actions/wallsAction";
import { useNavigate } from "react-router-dom";
import { LIVE_API, HOST_URL } from "../../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

function CreateWallPopup(props) {

  const navigate = useNavigate();

  const [loader, setLoader] = useState('false');
  const [state, setState] = useState({
    wallName: null,
    wallUrl: null,
    profanity: 0,
    status: 1,
    autoUpdate: 1,
    delete: 0,
    id: '',
    nameError: false,
    urlError: false,
    rename_status: 0
  });
  const { onHide } = props;
  const dispatch = useDispatch();

  const onWallName = (e) => {
    let result = e.target.value.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    setState({ ...state, wallName: e.target.value, wallUrl: result, nameError: false, urlError: false });
  };

  const onWallUrl = (e) => {
    let result = e.target.value.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    setState({ ...state, wallUrl: result, urlError: false });
  };

  const onProfanityFilterStatus = (e) => {
    setState({ ...state, profanity: state.profanity === 1 ? 0 : 1 });
  };

  const onSubmitWallData = (e) => { //rename_status

    if ((state.wallName && state.wallName.length > 0) && (state.wallUrl && state.wallUrl.length > 0)) {
      setLoader(true);
      setTimeout(() => {
        dispatch(widgetWallUpdate({
          name: state.wallName,
          url: state.wallUrl,
          profanity: state.profanity,
          status: state.status,
          autoUpdate: state.autoUpdate,
          delete: state.delete,
          id: state.id ? state.id : "",
        }, () => onHide(), () => setState({
          wallError: true,
          submitErrorMessage: "",
          apiRequest: false,
        }), navigate, props.rename_status))
        setLoader(false)
        if (props.setupdateWall && props.rename_status) {
          props.setupdateWall(Math.floor(Math.random() * 10))
        }
      }, 1000);

    } else {
      if (state.wallName == null || state.wallName.length == 0) setState({ ...state, nameError: true });
      if (state.wallUrl == null || state.wallUrl.length == 0) setState({ ...state, urlError: true });
      if ((state.wallName == null || state.wallName.length == 0) && (state.wallUrl == null || state.wallUrl.length == 0)) setState({ ...state, nameError: true, urlError: true });
    }
  };

  useEffect(() => {
    setState(state => ({ ...state, profanity: props.profanity, wallName: props.name, wallUrl: props.url, autoUpdate: props.autoUpdate, id: props.wall_id, rename_status: props.rename_status, nameError: false, urlError: false }))
  }, [props])

  return (
    <Modal className="sw_theme"
      show={props.show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <div className="modal-content">
        <div className="modal-header create-wall justify-content-between">
          <h4 className="modal-title">{state.rename_status == 1 ? 'Edit' : 'Create'} Display Wall </h4>
          <Button variant="link" className="px-2 float-end " onClick={onHide}>
            <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass='' />
          </Button>
        </div>
        <div className="maintainPopUp"
          id="WallCreateForm"
          method="post"
          acceptCharset="utf-8">
          <div className="modal-body">
            <div id="createWallBlock">
              <div className="panel-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="wallsname">
                        Wall Name<span className="required">*</span>
                      </label>
                      <div className="">
                        <input
                          name="Wall_Name"
                          placeholder="Enter your wall name e.g. myfirstwall" autoComplete="off" value={state.wallName} onChange={onWallName} className="form-control validate" id="wallsname" maxLength="255" type="text" required />
                      </div>
                      <span
                        id="wallsnameerror"
                        className="errorMessage required"
                      >{state.nameError ? 'Wall Name is required' : ''}</span>
                    </div>

                    <div className="form-group">
                      <label htmlFor="wallsurl" className="control-label">
                        Your Unique URL<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            {!LIVE_API ? 'display-test.socialwalls.com' : 'display.socialwalls.com/'}
                          </span>
                        </div>
                        <input
                          name="Wall_Url"
                          className="form-control validate"
                          id="wallsurl"
                          readOnly
                          value={state.wallUrl}
                          onChange={onWallUrl}
                          maxLength="255"
                          type="text"
                          required
                        />

                        {state.rename_status == 1 && <div className="input-group-append">
                          <a href={`${LIVE_API ? 'https://display.taggbox.com/' : `${HOST_URL}/display/v1/s/`}${state.wallUrl}`} target="_blank" id="blank_link" className="input-group-text"><i className="fa fa-external-link-alt icon-nm"></i></a>
                        </div>}
                      </div>
                      <span
                        id="wallsurlerror"
                        className="errorMessage required"
                      >{state.urlError ? 'Wall URL is required' : ''}</span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div>
                      <label className="form-check m-0 p-0 me-2" htmlFor="wallscreateprofanity">
                        <input type="hidden" name="Wall_Profanity" id="wallscreateprofanity_" value="0" />
                        <input type="checkbox" className="form-check-input me-2" name="Wall_Profanity" onChange={onProfanityFilterStatus} checked={state.profanity ? true : false} id="wallscreateprofanity" />
                        Profanity Filter
                      </label>
                    </div>

                    <div className="example-jsx">
                      <OverlayTrigger placement="right" overlay={<Tooltip id="profanity-filter-tooltip">This will make all the posts having inappropriate or vulgar words to get disapproved automatically. You can find them later in Private Posts Section in Moderation.</Tooltip>}>
                        <span>
                          <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary m-0 me-3" onClick={onHide}>
              Close
            </button>
            <button type="submit" onClick={onSubmitWallData}
              className={`${loader == true ? 'ladda-button spinner spinner-white spinner-right disabled ' : ''} btn btn-primary m-0 me-0`}
            >
              {state.rename_status === 1 ? `Update Wall` : `Create Wall`}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CreateWallPopup;
